// extracted by mini-css-extract-plugin
export var fadeIn = "_mt-1";
export var modalContent = "_mt-3";
export var overlay = "_mt-0";
export var popoverContent = "_mt-2";
export var results = "_mt-5";
export var searchInputWrapper = "_mt-4";